export default [
    { id: 'PHARMACARE', name: 'PHARMACARE' },
    { id: 'DS PHARMA', name: 'DS PHARMA' },
];
